// admin
import axios from 'axios';
export const updateFileDocumentsOnly = async (id: number, fileDocumentsIds: number[]) => {
  const { data: res } = await axios.put(`/admin/files/${id}/documents`, { fileDocumentsIds });
  return res;
};

export const updateFilePhotoOnly = async (id: number, filePhotosIds: number[]) => {
  const { data: res } = await axios.put(`/admin/files/${id}/photos`, { filePhotosIds });
  return res;
};

export const deleteFileDocuments = async (id: number) => {
  const { data: res } = await axios.delete(`/admin/files/${id}/documents`);
  return res;
};

export const deleteFilePhotos = async (id: number) => {
  const { data: res } = await axios.delete(`/admin/files/${id}/photos`);
  return res;
};
